import React from 'react'
import PropTypes from 'prop-types'
import { withCookies } from 'react-cookie'
import { ApolloProvider as ApolloHooksProvider } from '@apollo/client'
import { getApolloClient } from '@cred/shared/apollo'
import uuidGenerator from 'uuid/v1'
import config from 'config'

const withApolloProvider = WrappedComponent => {
  let apolloClient

  const WithApolloProvider = props => {
    if (!apolloClient) {
      apolloClient = getApolloClient(props.cookies, {
        uri: config.graphqlUri,
        headers: {
          'session-id': uuidGenerator(),
        },
        redirect: url => window.location.href = url,
      })
    }

    return (
      <ApolloHooksProvider client={apolloClient}>
        <WrappedComponent {...props} />
      </ApolloHooksProvider>
    )
  }

  WithApolloProvider.propTypes = {
    cookies: PropTypes.object.isRequired,
  }

  return withCookies(WithApolloProvider)
}

export default withApolloProvider
